module.exports = __webpack_public_path__ + "static/media/logo.40cd74ae.svg";